/**
 * Browser stub for packages excluded via the browser field (default-import consumers).
 *
 * Used for packages like `bittorrent-lsd` that are:
 *   1. Mapped to `false` in the browser field of their consumer package
 *      (e.g. torrent-discovery/package.json: "bittorrent-lsd": false)
 *   2. Imported as a default import:  `import LSD from 'bittorrent-lsd'`
 *
 * WHY export default undefined (not a class, not {}):
 *
 *   torrent-discovery/index.js guards LSD usage with:
 *     if (opts.lsd === false || typeof LSD !== 'function') {
 *       this.lsd = null  // ← correct browser path
 *     }
 *
 *   `typeof undefined !== 'function'` → true → LSD init skipped. ✓
 *
 * WHY ESM (not CJS `module.exports = {}`):
 *
 *   torrent-discovery is an ES module ("type": "module" in package.json).
 *   Rollup 4.x enforces strict ESM static analysis. CJS modules aliased
 *   as replacements for ESM default imports fail at the CJS→ESM interop
 *   boundary (DEFAULT_NOT_EXPORTED / traceVariable errors).
 *   A native ESM `export default` avoids this entirely.
 */
export default undefined;
